import Types from './types';
import { createReducer } from 'reduxsauce';
import { TOAST_OPTIONS } from '../../constants/app-constants';

const INITIAL_STATE = {
    autoHideDuration: 5000,
    message: 'Sample toast message',
    type: TOAST_OPTIONS.ERROR,
    vertical: 'bottom', horizontal: 'center'
};

const setToastMessage = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
        type: data?.type || TOAST_OPTIONS.ERROR,
        open: true,
    };
};

const resetToastMessage = (state = INITIAL_STATE) => {
    return {
        ...state,
        open: false,
    };
};

export const HANDLERS = {
    [Types.SET_TOAST]: setToastMessage,
    [Types.RESET_TOAST]: resetToastMessage
};

export default createReducer(INITIAL_STATE, HANDLERS);